import { call, put, select, takeEvery } from "redux-saga/effects"
import {
  getCohortReportList,
  hideCohortReportListLoader,
  hideCohortReportOptionsLoader,
  hideCohortReportParamsForFragmentationLoader,
  setCohortReportCohortSetup,
  setCohortReportList,
  setCohortReportOptions,
  setCohortReportParamsForFragmentation,
  setCohortReportProfile,
  setCohortReportShowFilter, setCohortReportTemplate, setCohortReportTemplates,
  setErrorCohortReportProfile,
  showCohortReportListLoader,
  showCohortReportOptionsLoader,
  showCohortReportParamsForFragmentationLoader
} from "./actions"
import { changeQuery, download, getErrorMessage, showErrorMessage, showSuccessMessage } from "../../helpers/utils"
import {
  ADD_COHORT_REPORTS,
  CHANGE_COHORT_REPORTS_TEMPLATE,
  DELETE_COHORT_REPORTS,
  DOWNLOAD_COHORT_REPORTS_DATA,
  INIT_COHORT_REPORTS,
  GET_COHORT_REPORTS_LIST,
  GET_COHORT_REPORTS_OPTIONS,
  GET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION,
  GET_COHORT_REPORTS_PROFILE,
  GET_COHORT_REPORTS_TEMPLATES,
  PATCH_COHORT_REPORTS_COHORT_SETUP,
  UPDATE_COHORT_REPORTS_PROFILE,
  SAVE_COHORT_REPORTS_TEMPLATE,
  CREATE_COHORT_REPORTS_TEMPLATE,
  DELETE_COHORT_REPORTS_TEMPLATE
} from "./actionTypes"
import {
  deleteCohortReport, deleteCohortReportTemplates,
  getCohortReport, getCohortReportFilterData,
  getCohortReportOptions,
  getCohortReportParamsForFragmentation,
  getCohortReportProfile, getCohortReportTemplates,
  patchCohortReportProfile, patchCohortReportTemplates,
  postCohortReport, postCohortReportTemplates
} from "../../helpers/jwt_helper"
import { getApplications } from "../apps/actions"
import { DATA_FORMAT_OPTIONS, DATE_OPTIONS, EVENT_OPTIONS } from "../../pages/Reporting/CohortReports"
import qs from "querystring"

// Chat Redux States

const getValidParams = data => {
  const params = { ...data }

  const keys = params.group_by.map(i => i.value)
  params.group_by = keys.join(",")
  params.days = params.days.value
  params.trend_type = params.trend_type.value
  params.cohort_type = params.cohort_type.value

  const filter_by_params = {}
  params.filter_by.forEach(({ value: { value }, sub_value }) => {
    filter_by_params[value] = sub_value.map(i => i.value).join(",")
  })

  params.filter_by = undefined
  return {
    ...params,
    ...filter_by_params
  }
}

function* onGetCohortReportList({ payload: { url = "/", params = {} } }) {
  try {
    yield put(showCohortReportListLoader())
    const keys = params.group_by.map(i => i.value)

    params = getValidParams(params)
    yield put(setCohortReportList([]))
    let response = yield call(getCohortReport, params, url)

    // console.log({response})

    const result = []
    const handleParseData = (data, idx = 0, sub_params = {}) => {
      if (idx === keys.length) {
        result.push({
          ...sub_params,
          days: (new Array(params.days).fill(0)).map((_, index) => data[index.toString()]),
          users: data.users,
          spend: data.spend
        })
        return void 0
      }

      for (let k in data) {
        handleParseData(data[k], idx + 1, {
          ...sub_params,
          [keys[idx]]: k
        })
      }
    }

    handleParseData(response)

    yield put(setCohortReportList(result))
    yield put(hideCohortReportListLoader())
  } catch (error) {
    yield put(hideCohortReportListLoader())
    showErrorMessage(getErrorMessage(error))
  }
}

function* onAddCohortReport({ payload: { COHORT_REPORTS, data } }) {
  try {
    yield put(showCohortReportListLoader())
    yield call(postCohortReport, COHORT_REPORTS)
    // yield call(onGetCohortReportList, { payload: data });
    yield put(hideCohortReportListLoader())
    showSuccessMessage("Legal entity has been added")
  } catch (error) {
    yield put(hideCohortReportListLoader())
    showErrorMessage(getErrorMessage(error))
  }
}

function* onDeleteCohortReport({ payload: { id, data } }) {
  try {
    yield put(showCohortReportListLoader())
    yield call(deleteCohortReport, id)
    yield call(onGetCohortReportList, { payload: data })
    yield put(hideCohortReportListLoader())
    showSuccessMessage("Legal entity has been deleted")
  } catch (error) {
    yield put(hideCohortReportListLoader())
    showErrorMessage(getErrorMessage(error))
  }
}

function* onGetCohortReportProfile({ payload: id }) {
  try {
    yield put(setErrorCohortReportProfile(false))
    let response = yield call(getCohortReportProfile, id)
    yield put(setCohortReportProfile(response))
  } catch (error) {
    if (getErrorMessage(error) === "Not found.") {
      yield put(setErrorCohortReportProfile(true))
    } else {
      showErrorMessage(getErrorMessage(error))
    }
  }
}

function* onUpdateCohortReportProfile({ payload: { id, COHORT_REPORTS, data } }) {
  try {
    yield put(showCohortReportListLoader())
    yield call(patchCohortReportProfile, id, COHORT_REPORTS)
    yield call(getCohortReportList, { payload: data })
    yield put(hideCohortReportListLoader())
    showSuccessMessage("Legal entity has been updated")
  } catch (error) {
    yield put(hideCohortReportListLoader())
    showErrorMessage(getErrorMessage(error))
  }
}

function* onGetCohortReportOptions({ payload }) {
  try {
    // console.log(payload)
    yield put(showCohortReportOptionsLoader())
    payload = payload || ({ app_id: (yield select(state => state.CohortReportList.cohort_setup.app_id)) })
    let res = yield call(getCohortReportOptions, payload)
    const arr = res
      .map(({ options, label }) => ({ value: { label, value: label }, options })) // parsing
      .filter(({ options }) => options.filter(o => o.value).length > 0) // filter by empty sub-options

    res = {
      params: [],
      events: []
    }

    arr.forEach(i => {
      if (i.options[0].value.includes("?event")) {
        res.events.push(i)
      } else {
        res.params.push(i)
      }
    })
    yield put(setCohortReportOptions(res))
    yield put(hideCohortReportOptionsLoader())
    return res
  } catch (error) {
    yield put(hideCohortReportOptionsLoader())
    showErrorMessage(getErrorMessage(error))
  }
}

function* onGetCohortReportParamsForFragmentation({ payload }) {
  try {
    yield put(showCohortReportParamsForFragmentationLoader())
    let res = yield call(getCohortReportParamsForFragmentation)
    res = Object.keys(res).map(key => ({ label: res[key], value: key }))
    yield put(setCohortReportParamsForFragmentation(res))
    yield put(hideCohortReportParamsForFragmentationLoader())
    return res
  } catch (error) {
    yield put(hideCohortReportParamsForFragmentationLoader())
    showErrorMessage(getErrorMessage(error))
  }
}

function* onGetFilterBySubOptions(params) {
  const filter_by = []
  for (const item of params.filter_by) {
    try {
      const q = {
        ...item,
        sub_options: (item.sub_options && item.sub_options.length > 0)
          ? item.sub_options
          : (yield call(getCohortReportFilterData, {
            app_id: params.app_id,
            field: item.value?.value
          })).map(i => ({ value: i, label: i }))
      }
      filter_by.push(q)
    } catch (e) {

    }
  }
  yield put(setCohortReportCohortSetup({
    ...params,
    filter_by
  }))
}

function* onInitCohortReport({ payload: { data, parsed_query = {} } }) {
  try {
    yield put(getApplications())
  } catch (e) {
    showErrorMessage(e)
  }

  let templates = []
  try {
    templates = yield onGetCohortReportTemplates()
  } catch (e) {
  }

  const params_for_fragmentation = yield onGetCohortReportParamsForFragmentation({})

  const template = parsed_query.template ? templates.find(i => i.id.toString() === parsed_query.template.toString()) : undefined

  yield onChangeCohortReportTemplate({ payload: template || templates[0] })
}

function* onPatchCohortReportCohortSetup({
                                           payload: {
                                             params = {},
                                             callback = () => {
                                             },
                                             template = false,
                                             init = false
                                           } = {}
                                         }) {
  try {

    const { show_filter, cohort_setup } = yield select(state => state.CohortReportList)
    yield put(setCohortReportCohortSetup(params))

    let api = show_filter.v2th?.value
    let v1th = show_filter.v1th
    let dt = {}
    // const type_of_options = ['params', 'events'].includes(params.type_of_options) ? params.type_of_options : 'params'

    if (init || (!template && (params.app_id && cohort_setup.app_id) && params.app_id !== cohort_setup.app_id)) {
      const options = (yield onGetCohortReportOptions({
        payload: {
          app_id: params.app_id
        }
      })).params


      yield put(setCohortReportShowFilter({
        v1th: options[0].value, // 1th show select
        v2th: options[0].options[0], // 2th show select
        o2th: options[0].options // options for 2th show select
      }))

      api = options[0].options[0].value
      v1th = options[0].value
    }


    // debugger
    if (Array.isArray(v1th)) {
      dt.events = v1th.map(i => i.value).join(",")
    }

    yield onGetCohortReportList({
      payload: {
        params: {
          ...cohort_setup,
          ...params,
          ...dt
        },
        url: api
      }
    })

    callback()
  } catch (e) {
    console.error("Error", e)
    callback()
  }
}

function* onDownloadCohortReportData() {
  try {
    const { show_filter, cohort_setup } = yield select(state => state.CohortReportList)
    let api = show_filter.v2th.value
    const dt = {}
    if (Array.isArray(show_filter.v1th)) {
      dt.events = show_filter.v1th.map(i => i.value).join(",")
    }

    const params = getValidParams({ ...cohort_setup, ...dt })
    params.download = true
    let response = yield call(getCohortReport, params, api, { responseType: "blob" })
    download(URL.createObjectURL(response))
  } catch (e) {
    console.error(e)
    showErrorMessage(e)
  }
}

function* onGetCohortReportTemplates() {
  try {
    let res = yield call(getCohortReportTemplates)
    // res = res.map(i => ({ label: i.name, value: i.data }))
    yield put(setCohortReportTemplates(res))
    return res
  } catch (e) {
    return []
  }
}

const getAppId = () => {
  const a = window.location.pathname.split("/")
  return a[a.length - 1] || a[a.length - 2]
}

function* getStringifyTemplate() {
  const data = {
    ...(yield select(state => state.CohortReportList.cohort_setup)),
    ...(yield select(state => state.CohortReportList.show_filter))
  }

  const params = {}

  // Group by
  params.group_by = data.group_by.map(i => i.value)

  // Filter by
  params.filter_by = {}
  data.filter_by.forEach(i => {
    params.filter_by[i.value.value] = i.sub_value.map(v => v.value)
  })

  // Days
  params.days = data.days?.value || 30

  // Show
  params.show = Array.isArray(data.v1th)
    ? `${data.v2th.value}?events=${data.v1th.map(i => i.value).join(",")}`
    : data.v2th.value

  // Type
  params.type = data.type

  // App id
  params.app_id = data.app_id || getAppId()
  return JSON.stringify(params)
}

function* onSaveCohortReportTemplate({ payload } = {}) {
  try {
    const { template, templates } = yield select(state => state.CohortReportList)
    if (!template) return void 0

    const req = { ...template, data: yield getStringifyTemplate(), ...payload }
    const res = yield call(patchCohortReportTemplates, template.id, req)
    yield put(setCohortReportTemplates(templates.map(i => i.id === template.id ? res : i)))
    showSuccessMessage("Template has been updated")
  } catch (e) {
    console.error(e)
    showErrorMessage(e)
  }
}

function* onCreateCohortReportTemplate({ payload } = {}) {
  try {
    const { templates } = yield select(state => state.CohortReportList)
    const res = yield call(postCohortReportTemplates, { data: yield getStringifyTemplate(), ...payload })
    yield put(setCohortReportTemplates([...templates, res]))
    yield onChangeCohortReportTemplate({payload: res})
    showSuccessMessage("Template has been created")
  } catch (e) {
    console.error(e)
    showErrorMessage(e)
  }
}

function* onDeleteCohortReportTemplate({ payload } = {}) {
  try {
    const { template, templates } = yield select(state => state.CohortReportList)
    if (!template || template?.id < 0) return void 0;
    yield call(deleteCohortReportTemplates, template.id)
    yield put(setCohortReportTemplates(templates.filter(i => i.id !== template.id)))
    yield onChangeCohortReportTemplate({payload: templates[0]})
    showSuccessMessage("Template has been deleted")
  } catch (e) {
    console.error(e)
    showErrorMessage(e)
  }
}

function* getParsedTemplate(parsed_query) {
  if (parsed_query.days) {
    parsed_query.days = DATE_OPTIONS.find(i => i.value.toString() === parsed_query.days.toString()) || DATE_OPTIONS[0]
  }

  const data = {
    ...(yield select(state => state.CohortReportList.cohort_setup))
  }

  data.app_id = data.app_id || parsed_query.app_id || getAppId()

  const type_of_options = parsed_query?.show?.includes("?events=") ? "events" : "params"
  let show_filter = undefined
  const options = (yield onGetCohortReportOptions({
    payload: {
      app_id: data.app_id
    }
  }))[type_of_options]

  // let show_item = (parsed_query.show && options.find(i => i.options.some(o => o.value === parsed_query.show))) || options[0]
  let show_item = options[0]

  if (type_of_options === "events") { // events options in show
    let [show_api, event_keys] = parsed_query.show.split("?events=")
    event_keys = event_keys.split(",").filter(i => i !== "")
    show_filter = {
      v1th: event_keys.map(i => ({ value: i, label: i })), // 1th show select
      v2th: EVENT_OPTIONS.find(i => i.value === show_api) || EVENT_OPTIONS[0],
      o2th: EVENT_OPTIONS // options for 2th show select
    }
  } else { // params options in show
    show_item = (parsed_query.show && options.find(i => i.options.some(o => o.value === parsed_query.show))) || options[0]

    show_filter = {
      v1th: show_item.value, // 1th show select
      v2th: (parsed_query.show && show_item.options.find(i => i.value === parsed_query.show)) || show_item.options[0], // 2th show select
      o2th: show_item.options // options for 2th show select
    }
  }

  const params_for_fragmentation = yield select(state => state.CohortReportList.params_for_fragmentation)

  let params = {
    ...data
  }

  if (parsed_query.group_by) {
    try {
      parsed_query.group_by = parsed_query.group_by.map(i => params_for_fragmentation.find(el => el.value.toString() === i))
    } catch (e) {
      console.error("Parse group by at INIT: ", e)
      parsed_query.group_by = [params_for_fragmentation[0]]
    }
  } else {
    params.group_by = [params_for_fragmentation[0]]
  }

  if (parsed_query.filter_by) {
    const filter_by = []
    for (const key in parsed_query.filter_by) {
      filter_by.push({
        value: params_for_fragmentation.find(el => el.value.toString() === key),
        sub_value: parsed_query.filter_by[key].map(el => ({ label: el, value: el })),
        sub_options: []
      })
    }
    parsed_query.filter_by = filter_by
  } else {
    params.filter_by = []
  }

  params = {
    ...params,
    ...parsed_query
  }
  return [params, show_filter]
}

function* onChangeCohortReportTemplate({ payload }) {
  const [params, show_filter] = yield getParsedTemplate({...payload.data})
  yield put(setCohortReportShowFilter(show_filter))
  yield onPatchCohortReportCohortSetup({ payload: { params, template: true } })
  yield onGetFilterBySubOptions(params)
  yield put(setCohortReportTemplate(payload))
  changeQuery({ template: payload.id })

  if (params.app_id) {
    window.history.replaceState(null, "", `/quality-cohort-report/${params.app_id}${window.location.search}`) // change match param app_id (without reload)
  }
}

function* CohortReportListSaga() {
  yield takeEvery(GET_COHORT_REPORTS_LIST, onGetCohortReportList)
  yield takeEvery(DELETE_COHORT_REPORTS, onDeleteCohortReport)
  yield takeEvery(ADD_COHORT_REPORTS, onAddCohortReport)
  yield takeEvery(GET_COHORT_REPORTS_PROFILE, onGetCohortReportProfile)
  yield takeEvery(UPDATE_COHORT_REPORTS_PROFILE, onUpdateCohortReportProfile)
  yield takeEvery(GET_COHORT_REPORTS_OPTIONS, onGetCohortReportOptions)
  yield takeEvery(GET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION, onGetCohortReportParamsForFragmentation)
  yield takeEvery(INIT_COHORT_REPORTS, onInitCohortReport)
  yield takeEvery(DOWNLOAD_COHORT_REPORTS_DATA, onDownloadCohortReportData)
  yield takeEvery(GET_COHORT_REPORTS_TEMPLATES, onGetCohortReportTemplates)
  yield takeEvery(CHANGE_COHORT_REPORTS_TEMPLATE, onChangeCohortReportTemplate)
  yield takeEvery(SAVE_COHORT_REPORTS_TEMPLATE, onSaveCohortReportTemplate)
  yield takeEvery(CREATE_COHORT_REPORTS_TEMPLATE, onCreateCohortReportTemplate)
  yield takeEvery(DELETE_COHORT_REPORTS_TEMPLATE, onDeleteCohortReportTemplate)
  yield takeEvery(PATCH_COHORT_REPORTS_COHORT_SETUP, onPatchCohortReportCohortSetup)
}

export default CohortReportListSaga
